<template>
  <div class="lanSet">
    <el-table :height="620" class="table-container" :data="serveDataList"
      @sort-change="sortChanged" :cell-class-name="addEnClass" :default-sort="{ prop: '', order: 'descending' }">
      <template slot="empty">
        <load-skeleton v-show="loading" :columns="6" :rows="10" :haveLeftNumber="false"></load-skeleton>
        <h4 class="common-table-noData" v-show="!loading">
          <img src="../../assets/images/v4_nodata.png" alt="" />
          <div class="noData-text">
            {{ $t("common.noData") }}
          </div>
        </h4>
      </template>
      <!--  序号 -->
      <el-table-column prop="sort" align="left" :label="$t('publicManage.lanset.sort')" width="150">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>

      </el-table-column>
      <!--  语言描述 -->
      <el-table-column prop="langName" align="right" :label="$t('publicManage.basenav.language')">
      </el-table-column>
      <!-- 文件名 -->
      <el-table-column prop="fileName" align="right" :label="$t('publicManage.lanset.fileName')">
        <template slot-scope="scope">
          <span> {{ scope.row.langKey + ".json" }}</span>
        </template>
      </el-table-column>
      <!--  状态-->
      <el-table-column prop="desc" align="right" :label="$t('publicManage.lanset.status')">
        <template slot-scope="scope">
          <span :class="scope.row.status === 0 ? 'red' : 'green'">
            {{
      scope.row.status === 0
        ? $t("publicManage.lanset.pause")
        : $t("publicManage.lanset.startUse")
    }}
          </span>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column prop="action" :label="$t('common.find')" fixed="right" align="right">
        <template slot-scope="scope">
          <b-button size="sm" variant="outline-primary" @click="
      modify(
        scope.row.langKey,
        'server',
        scope.row.nowFileAddress,
        scope.row.backupFileAddress
      )
      ">
            <!-- 编辑 -->
            {{ $t("common_language.editor") }}
            <!-- {{$t('exTrade.eidt')}} -->
          </b-button>
          <b-button size="sm" variant="outline-primary" @click="reset(scope.row.langKey, 'serve', scope.row.id)">
            <!-- 还原 -->
            {{ $t("publicManage.lanset.reset") }}
            <!-- {{$t('exTrade.eidt')}} -->
          </b-button>
          <b-button :disabled="scope.row.langKey === 'en_US'" size="sm"
            :variant="scope.row.status ? 'outline-primary' : 'outline-primary'" @click="handleSwitch(scope.row, 5)">
            <!-- 启用/停用 -->
            {{
      scope.row.status === 0
        ? $t("publicManage.lanset.startUse")
        : $t("publicManage.lanset.pause")
    }}
            <!-- {{$t('exTrade.eidt')}} -->
          </b-button>

        </template>
      </el-table-column>
    </el-table>
    <b-modal v-model="statusFlag" :title="$t('publicManage.lanset.tip')" id="small-modal" no-close-on-backdrop>
      <section>
        <p class="modal-titles">
          {{
      $t("publicManage.lanset.statusTitle", {
        lang: activeRow.langName,
      })
    }}
        </p>
        <p v-if="tabIndex !== 3" class="modal-text">
          {{ $t("publicManage.lanset.statusText") }}
        </p>
      </section>
      <section class="deilog-bottom" slot="modal-footer">
        <!-- 取消 -->
        <b-button class="coustom-btn" @click="switchCancel">
          {{ $t("publicManage.lanset.cancel") }}
        </b-button>
        <!-- 启用/停用 -->
        <b-button class="coustom-btn" variant="primary" @click="switchSubmit">
          <!-- {{ $t('publicManage.lanset.ok') }} -->
          {{
      activeRow.status === 0
        ? $t("publicManage.lanset.startUse")
          : $t("publicManage.lanset.pause")
          }}
        </b-button>
      </section>
    </b-modal>
  </div>
</template>

<script>
import commonMixin from "@/mixin/common/commonMixin";
export default {
  name: "languageService",
  components: {},
  mixins: [commonMixin],
  data() {
    return {
      tabIndex: 0,
      notData: false,
      loading: false,
      isOpen: null,
      isOpenType: [],
      webDataList: [],
      serveDataList: [],
      serverList: [],
      adminList: [],
      num: 0,
      fileUrl: null,
      uploadType: null,
      uploadLan: null,
      secoundClick: true,
      altersImg: require("@/assets/images/alerts.png"),
      aa: null,
      bb: null,
      addLanguageFlag: false,
      modalDisabled: false,
      statusFlag: false,
      activeRow: {
        text: "简体中文",
        type: "web",
        status: 0,
      },
      tabType: 5, //5服务端 6管理后台
    };
  },
  computed: {
    url() {
      return this.$store.state.url.imgUpload;
    },
    addText() {
      let text = "";
      this.isOpenType.forEach((item) => {
        if (this.isOpen === item.value) {
          text = item.text;
        }
      });
      return text;
    },
  },
  mounted() {
    // this.getLang();
    this.getDownloadAddress();
  },
  methods: {
    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "value":
          return "enNum";
      }
    },
    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "tradeAmount":
          this.sortName = "tradeAmount";
          break;
      }
      this.sortSet = ctx.order === "descending" ? 1 : 0;
    },
    // tab切换
    handleChangeTab(type) {
      this.tabType = type;
      this.getDownloadAddress(this.tabType);
    },
    addLan() {
      if (!this.secoundClick) return;
      this.secoundClick = false;
      this.addLanguageFlag = true;
    },
    langSure() {
      this.$http({
        url: "company_lang_add",
        params: {
          lang: this.isOpen,
        },
      }).then((data) => {
        if (data.code.toString() === "0") {
          console.log(data);
          // this.getLang();
          this.getDownloadAddress();
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
        this.secoundClick = true;
        this.addLanguageFlag = false;
      });
    },
    langCancel() {
      this.secoundClick = true;
      this.addLanguageFlag = false;
    },
    // 获取下载地址
    getDownloadAddress() {
      this.loading = true;
      this.$http({
        url: "language/langStatuList",
        params: {
          type: this.tabType, //服务端 5:管理后台6
        },
      }).then((data) => {
        this.loading = false;
        if (data.code.toString() === "0") {
          let arr1 = [];
          let arr2 = [];
          if (this.tabType === 5) {
            data.data.langStatuList.forEach((item) => {
              if (item.status == 1) {
                arr1.push(item);
              } else {
                arr2.push(item);
              }
            });
            arr1 = arr1.reverse();
            arr1 = arr1.concat(arr2);
            this.serveDataList = arr1;
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    modify(lan, type, address, backupAddress) {
      this.$router.push({
        path: "languageModify", // type !== "server" ? "languageModify" : "serverModify",
        query: { lan, type, address, backupAddress },
      });
    },
    // 服务端跳转
    modifyServe(lan, type, address, mtime) {
      this.$router.push({
        path: "serverModify",
        query: { lan, type, address, mtime },
      });
    },
    // 还原
    reset(langKey, type, id) {
      this.$bvModal
        .msgBoxConfirm(this.$t("publicManage.lanset.resetNote"), {
          title: this.$t("common.tip"),
          size: "md",
          buttonSize: "md",
          okTitle: this.$t("publicManage.lanset.ok"),
          cancelTitle: this.$t("publicManage.lanset.cancel"),
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            if (type === "serve") type = 5;
            const paramsData = {
              langKey,
              type,
              id,
            };
            this.$http({
              // url: "company_lang_cloud_address_update",
              url: "language/langFileReduce",
              params: paramsData,
            }).then(({ code, data, msg }) => {
              if (code.toString() === "0") {
                // this.getData();
                this.getDownloadAddress();
                this.$bus.$emit("alert", { type: "success", message: msg }); // '操作成功'
              } else {
                this.$bus.$emit("alert", { type: "error", message: msg });
              }
            });
          }
        })
        .catch((err) => { });
    },
    handleSwitch(row, type) {
      this.statusFlag = true;
      this.activeRow = row;
      this.activeType = type;
    },
    switchCancel() {
      this.statusFlag = false;
    },
    // 停用启用
    switchSubmit() {
      const { langKey, status } = this.activeRow;
      this.$http({
        // url: "onoff",
        url: "language/updateStatus",
        params: {
          langKey: langKey,
          status: status === 0 ? 1 : 0,
          type: this.activeType,
        },
      }).then((data) => {
        if (data.code.toString() === "0") {
          this.getDownloadAddress();
          this.statusFlag = false;
          this.$bus.$emit("alert", { type: "success", message: data.msg });
        } else {
          this.statusFlag = false;
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.basenav {
  .header {
    font-size: 15px;
  }

  .nav-tabs li {
    margin-right: 10px;
  }

  .nav-tabs .nav-link.active {
    cursor: default;
  }
}

.lanSet {
  .card {
    border-radius: 8px !important;
  }

  .lanList {
    width: 200px;
    float: left;
    margin-right: 40px;
  }

  button {
    margin-right: 10px;
  }

  .input-hide {
    display: none;
  }

  .note {
    margin-top: 15px;
    color: var(--theme-color-red);

    img {
      height: 15px;
      width: 15px;
      margin-right: 5px;
    }
  }
}

.modal-titles {
  text-align: center;
  margin-bottom: 10px;
  font-weight: 600;
}

.red {
  color: var(--theme-color-red);
}

.green {
  color: var(--theme-color-green);
}
</style>
